import { SingleOrder } from "../../organisms";
import React, { useMemo, useState } from "react";
import { useQueryClient } from "react-query";
import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router-dom";

import { findModel } from "../../templates/main-template/MainTamplate.utils";
import { useFilters } from "../../templates/filter-context/useFilters";
import { GET_ITEMS } from "../../../graphql/items";
import {
  getPayrollListQuery,
  getPayrollListRootField,
} from "../../../graphql/payroll";
import { MainTemplateLoading } from "../../templates/main-template/MainTemplate.styled";
import { Button, Empty, Flex, Result, Space, Spin } from "antd";
import { OrdersWraper } from "../../organisms/";
import { GlobalActions } from "../../molecules";

export const OrdersPage: React.FC = () => {
  const { filters } = useFilters();
  const queryClient = useQueryClient();
  const { name } = useParams();
  const models: any = queryClient.getQueryData(["/models"]);
  const [limit, setLimit] = useState(20);
  const [offset, setOffSet] = useState(0);
  const { model, error: modelError } = useMemo(() => findModel(models, name), [
    models,
    name,
  ]);

  const dataType = model?.data_type;
  const listQuery = getPayrollListQuery(dataType) ?? GET_ITEMS;
  const listRootField = getPayrollListRootField(dataType) ?? "items";

  const { data, error, loading } = useQuery(listQuery, {
    variables: { itemModelId: Number(model?.id), filter: filters, limit, offset },
    skip: !model || !filters,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  const listData = (data as any)?.[listRootField];
  const total = listData?.count ?? null;
  const global_actions = Array.isArray(listData?.globalActions) ? listData.globalActions : [];
  const items = listData?.results;
  const title_fields = model?.titleFields;
  const delete_permission = listData?.deletePermission;

  if (error || modelError) {
    return (
      <Result
        status="403"
        title="BŁĄD"
        subTitle="Przepraszamy, wystąpił błąd. Skontaktuj się z administratorem"
        extra={<Button type="primary">Back Home</Button>}
      />
    );
  }

  return (
    <OrdersWraper
      limit={limit}
      setLimit={setLimit}
      setOffSet={setOffSet}
      total={total}
      isFetching={loading}
      global_actions={global_actions}
    >
      {Array.isArray(items) && items?.length > 0
        ? items.map((e: any) => {
            return (
              <SingleOrder
                key={e.id}
                id={e.id}
                item={e.item}
                labels={e.labels}
                background_color={e.backgroundColor}
                delete_permission={delete_permission}
                model={model}
                title_fields={title_fields}
                patch_url={model?.patchUrl}
                delete_url={model?.deleteUrl}
              />
            );
          })
        : data && (
            <>
              <Flex justify="flex-end">
                <Space size={"small"}>
                  <GlobalActions total={1} global_actions={global_actions} />
                </Space>
              </Flex>
              <Empty
                description={
                  Object.keys(filters || {}).length > 0
                    ? "Brak pasujących wyników do zaznaczonych filtrów"
                    : "Brak danych"
                }
              />
            </>
          )}

      {loading && (
        <MainTemplateLoading>
          <Spin size="large" />
        </MainTemplateLoading>
      )}
    </OrdersWraper>
  );
};
